export const FIND_ACCOUNT_LIST = [
  {
    qsymbol: '[Q]',
    question: '아이디를 변경하고 싶습니다.',
    asymbol: '[A]',
    answer: `한번 부여받으신 아이디는 변경하실 수 없습니다. 부득이하게 아이디 변경을 원하실 경우 회원탈퇴 후, 원하시는 아이디로 재가입하셔야 합니다. ※ 회원탈퇴를 하시면 작성된 이력서와 개인정보가 모두 영구히 삭제되어 복구가 불가능하므로 신중하게 생각하신 후 탈퇴를 하시기 바랍니다.`,
  },
  {
    qsymbol: '[Q]',
    question: '이메일로 비밀번호를 찾는데 메일이 오지 않아요.',
    asymbol: '[A]',
    answer: `가입자가 본인명의가 아닐 경우 메일 인증이 불가능하오니 인증번호를 받지 못하셨다면 먼저 본인명의로 가입된 이메일인지 확인해주세요. 만약 다른 사람이름으로 가입되어있다면 "이메일 비밀번호 찾기" 또는 아래 정보를 확인하여 고객센터로 문의 주시기 바랍니다. ■ 고객센터 ‘문의하기’ 내용 작성방법 - 제목 : [비밀번호 확인 요청] - 내용 * 개인회원 : 가입시 입력한 가입자명과 주민등록번호, 아이디 * 기업회원 : 가입시 입력한 담당자명과 주민등록번호,회사명,사업자번호,아이디 (기업회원은 가입시 입력한 회사 사업자등록증 사본은 팩스 또는 이메일로 발송해야 합니다.) - FAX : 02-6008-2059 / 이메일 : wkmin@elancer.co.kr`,
  },
];
